<div class="main-content table-page table-page--compact table-page--dense gestion-horarios-page">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Horarios laborales</h1>
        <p>Plantillas semanales de jornada y comida para asignar a cada colaborador.</p>
      </div>
      <div class="table-page__toolbar-actions">
        <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary" (click)="irAsignacion()">
          <span class="material-icons">manage_accounts</span>
          Asignaciones
        </button>
        <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="nuevoHorario()">
          <span class="material-icons">schedule</span>
          Nuevo horario
        </button>
      </div>
    </section>

    <section class="table-page__card">
      <div class="table-page__toolbar table-page__toolbar--filters">
        <div class="table-page__filters-grid">
          <div class="table-page__filter table-page__filter--wide">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Nombre del horario</mat-label>
              <input matInput [(ngModel)]="filtroNombre" (keyup.enter)="consultarHorarios()" aria-label="Nombre del horario" />
            </mat-form-field>
          </div>
          <div class="table-page__filter table-page__filter--medium">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Estatus</mat-label>
              <mat-select [(ngModel)]="filtroEstatus" (selectionChange)="consultarHorarios()">
                <mat-option value="ACTIVO">Activo</mat-option>
                <mat-option value="INACTIVO">Inactivo</mat-option>
                <mat-option [value]="null">Todos</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="table-page__toolbar-actions">
          <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary" (click)="clearFilters()">
            <span class="material-icons">filter_alt_off</span>
            Limpiar
          </button>
          <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="consultarHorarios()">
            <span class="material-icons">search</span>
            Consultar
          </button>
        </div>
      </div>

      <div class="table-page__table-wrap" *ngIf="horarios.length > 0; else horariosEmptyState">
        <table class="table-page__table">
          <thead>
            <tr>
              <th>Horario</th>
              <th>Descripción</th>
              <th>Jornada semanal</th>
              <th>Tolerancia</th>
              <th>Estatus</th>
              <th class="table-page__actions-head">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let horario of horarios">
              <td>
                <div class="table-page__cell-stack">
                  <strong class="table-page__name">{{ horario.nombre }}</strong>
                  <span class="table-page__subtext">ID {{ horario.id || "-" }}</span>
                </div>
              </td>
              <td><span class="table-page__text">{{ horario.descripcion || "Sin descripción" }}</span></td>
              <td><span class="table-page__text">{{ getDiasConfigurados(horario) }}</span></td>
              <td><span class="table-page__text">{{ getTolerancia(horario) }}</span></td>
              <td><span [class]="getStatusClass(horario.estatus)">{{ horario.estatus || "-" }}</span></td>
              <td class="table-page__actions">
                <button type="button" class="table-page__action-btn" title="Editar" aria-label="Editar"
                        (click)="editarHorario(horario)">
                  <span class="material-icons">edit_calendar</span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <ng-template #horariosEmptyState>
        <div class="table-page__empty" *ngIf="!loading; else horariosLoadingState">
          <span class="material-icons">schedule_send</span>
          <h3>No hay horarios registrados</h3>
          <p>Comience creando una plantilla semanal para poder asignarla a sus colaboradores.</p>
        </div>
      </ng-template>

      <ng-template #horariosLoadingState>
        <div class="table-page__empty table-page__empty--loading">
          <span class="material-icons">hourglass_top</span>
          <h3>Cargando horarios</h3>
          <p>Espere un momento mientras se consulta la configuración disponible.</p>
        </div>
      </ng-template>
    </section>
  </div>
</div>
